package alltravelagents

import com.essntl.features.travelagent.domain.model.TravelAgentModel

interface AllTravelAgentsEvent {
    data class LoadTravelAgents(val travelAgent: TravelAgentModel? = null) : AllTravelAgentsEvent
    data class SearchTravelAgent(val query: String) : AllTravelAgentsEvent
}